module.exports = __webpack_public_path__ + "static/media/spinner.ee4e09d8.svg";